<!-- <template>
  <div class="app-container" :class="{ 'sidebar-open': $store.state.sidebarOpen }">
    <header class="header">
      <button class="menu-toggle" @click="$store.commit('toggleSidebar')">
        <span class="menu-icon"></span>
      </button>
      <div class="logo">
        <router-link to="/">开发者文档</router-link>
      </div>
    </header>
    
    <div class="content-wrapper">
      <DocSidebar />
      <main class="main-content" @click="$store.commit('closeSidebar')">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
import DocSidebar from './components/DocSidebar.vue'

export default {
  name: 'App',
  components: {
    DocSidebar
  }
}
</script>

<style>
:root {
  --primary-color: #3498db;
  --text-color: #333;
  --sidebar-width: 280px;
  --header-height: 60px;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  color: var(--text-color);
  line-height: 1.6;
}

.app-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.header {
  height: var(--header-height);
  display: flex;
  align-items: center;
  padding: 0 20px;
  border-bottom: 1px solid #eee;
  position: fixed;
  width: 100%;
  background: white;
  z-index: 100;
}

.logo {
  font-weight: bold;
  font-size: 1.2rem;
}

.logo a {
  color: var(--primary-color);
  text-decoration: none;
}

.menu-toggle {
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  margin-right: 15px;
}

.menu-icon {
  display: block;
  width: 25px;
  height: 3px;
  background: var(--text-color);
  position: relative;
}

.menu-icon:before,
.menu-icon:after {
  content: '';
  width: 25px;
  height: 3px;
  background: var(--text-color);
  position: absolute;
  left: 0;
}

.menu-icon:before {
  top: -8px;
}

.menu-icon:after {
  bottom: -8px;
}

.content-wrapper {
  display: flex;
  flex: 1;
  padding-top: var(--header-height);
}

.main-content {
  flex: 1;
  padding: 30px;
  margin-left: var(--sidebar-width);
  transition: margin 0.3s;
}

@media (max-width: 768px) {
  .menu-toggle {
    display: block;
  }
  
  .main-content {
    margin-left: 0;
  }
  
  .sidebar-open .main-content {
    opacity: 0.7;
  }
}
</style> -->

<template>
  <div class="app-container" :class="{ 'sidebar-open': $store.state.sidebarOpen }">
    <header class="header">
      <button class="menu-toggle" @click="$store.commit('toggleSidebar')">
        <span class="menu-icon"></span>
      </button>
      <div class="logo">
        <router-link to="/">开发者文档（鸿蒙版）</router-link>
      </div>
      <nav class="header-nav">
        <a href="https://pdf.foxhank.top" target="_blank">主页</a>
        <a href="https://developer.pdf.foxhank.top" target="_blank">API 控制台</a>
        <router-link to="/download">下载中心</router-link>
        <router-link to="/docs/9">联系我们</router-link>
      </nav>
    </header>
    
    <div class="content-wrapper">
      <DocSidebar />
      <main class="main-content" @click="$store.commit('closeSidebar')">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
import DocSidebar from './components/DocSidebar.vue'

export default {
  name: 'App',
  components: {
    DocSidebar
  }
}
</script>

<style>
:root {
  --primary-color: #3498db;
  --text-color: #333;
  --sidebar-width: 280px;
  --header-height: 60px;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  color: var(--text-color);
  line-height: 1.6;
}

.app-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.header {
  height: var(--header-height);
  display: flex;
  align-items: center;
  padding: 0 20px;
  border-bottom: 1px solid #eee;
  position: fixed;
  width: 100%;
  background: white;
  z-index: 100;
}

.logo {
  font-weight: bold;
  font-size: 1.2rem;
}

.logo a {
  color: var(--primary-color);
  text-decoration: none;
}

.menu-toggle {
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  margin-right: 15px;
}

.menu-icon {
  display: block;
  width: 25px;
  height: 3px;
  background: var(--text-color);
  position: relative;
}

.menu-icon:before,
.menu-icon:after {
  content: '';
  width: 25px;
  height: 3px;
  background: var(--text-color);
  position: absolute;
  left: 0;
}

.menu-icon:before {
  top: -8px;
}

.menu-icon:after {
  bottom: -8px;
}

.header-nav {
  display: flex;
  margin-left: auto;
}

.header-nav a {
  color: var(--text-color);
  text-decoration: none;
  margin-left: 20px;
  transition: color 0.3s;
}

.header-nav a:hover {
  color: var(--primary-color);
}

.content-wrapper {
  display: flex;
  flex: 1;
  padding-top: var(--header-height);
}

.main-content {
  flex: 1;
  padding: 30px;
  margin-left: var(--sidebar-width);
  transition: margin 0.3s;
}

@media (max-width: 768px) {
  .menu-toggle {
    display: block;
  }
  
  .main-content {
    margin-left: 0;
  }
  
  .sidebar-open .main-content {
    opacity: 0.7;
  }

  .header-nav {
    display: none;
  }
}
</style>

